import { render, staticRenderFns } from "./contato-externo.vue?vue&type=template&id=fb25db6e"
import script from "./contato-externo.vue?vue&type=script&lang=js"
export * from "./contato-externo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports